// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"57461b47","977":"ed844e7a"}[chunkId] + ".chunk.js";
};